import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useIntercom } from 'react-use-intercom';

const Intercom = ({ intercomInfo, isIntercomInfoFetched, fetchIntercomInfo, children }) => {
    const [userHash, setUserHash] = useState('');
    const { boot, update } = useIntercom();
    const { name } = intercomInfo;

    useEffect(() => {
        fetchIntercomInfo(hash => setUserHash(hash));
    }, []);

    useEffect(() => {
        if (isIntercomInfoFetched) {
            /**
             * Method which boots the Intercom instance.
             * After boot, Intercom widget will be available.
             * @param {string} userHash hash with all necessary user data
             * @param {string} name user name which will be showing in the widget
             */
            boot({
                userHash,
                name,
            });
        }
    }, [isIntercomInfoFetched]);

    useEffect(() => {
        if (isIntercomInfoFetched) {
            /**
             * Method which updates the Intercom instance with the supplied props.
             * @param {Object} customAttributes custom properties for Intercom
             */
            update({
                customAttributes: { ...intercomInfo },
            });
        }
    }, [intercomInfo]);

    return children;
};

Intercom.defaultProps = {
    intercomInfo: {},
    isIntercomInfoFetched: false,
    fetchIntercomInfo: () => {},
};

Intercom.propTypes = {
    intercomInfo: PropTypes.object,
    isIntercomInfoFetched: PropTypes.bool,
    fetchIntercomInfo: PropTypes.func,
    children: PropTypes.node.isRequired,
};

export default Intercom;
